module.exports = __webpack_public_path__ + "static/media/  (139).705909cc.jpg";